import React from "react";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import ManagerDetailModalComponent from "../../components/Std/ManagerDetailModal.jsx";
import AttachmentDescriptionModal from "../../components/Std/AttachmentDescriptionModal";

const AttachmentDescription = (props, context) => {
  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  return (
    <AttachmentDescriptionModal
      closeRemoveModal={closeRemoveModal}
      {...props}
    />
  );
};

AttachmentDescription.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default AttachmentDescription;
